import * as React from 'react'

import { User_user } from 'main/gql/user'
import { familyProfilePath } from 'main/routes'
import { Link, Strong } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../common'
import { Email, EmailContainer, NameContainer, Pipe, RowContainer } from './Profile.styles'

interface IProps {
  user: User_user
}

const PRE = `COMPONENTS-MENU-PROFILE`

export default function Profile(props: IProps) {
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const { user } = props

  return (
    <div>
      <RowContainer>
        <NameContainer>
          <Strong>{user.name}</Strong>
        </NameContainer>
        <Pipe>&nbsp;|&nbsp;</Pipe>
        <Link to={familyProfilePath()}>{t(`${PRE}-TEXT`)}</Link>
      </RowContainer>

      <EmailContainer>
        <Email>{user.email}</Email>
      </EmailContainer>
    </div>
  )
}
